module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/skills.json
// module id = 856
// module chunks = 152103125342432